import React, { useEffect, useState } from 'react';
import { movieApi } from 'api';
import { Loader } from 'Components/Loader';
import { Poster } from 'Components/Poster';
import { Section } from 'Components/Section';
import styled from 'styled-components';
import PageHeader from 'Components/PageHeader';
import { withRouter } from 'react-router-dom';
import useInfiniteScroll from 'useInfiniteScroll';
import uniqBy from 'lodash.uniqby';
import { Helmet } from 'react-helmet';

const Container = styled.div`
  padding: 0 20px;
`;

const Movie = ({ location: { pathname } }) => {
  const [popular, setPopular] = useState(null);
  const [topRated, setTopRated] = useState(null);
  const [nowPlaying, setNowPlaying] = useState([]);
  const [loading, setLoading] = useState(true);

  const page = useInfiniteScroll();

  const getMovie = async () => {
    try {
      const {
        data: { results: popular }
      } = await movieApi.popular();
      setPopular(popular);
      const {
        data: { results: topRated }
      } = await movieApi.topRated();
      setTopRated(topRated);
      const {
        data: { results: nowPlaying }
      } = await movieApi.nowPlaying();
      setNowPlaying(nowPlaying);
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const getInfiniteMovie = async () => {
    if (page !== 1) {
      if (pathname === '/movie') {
        try {
          const {
            data: { results: newPopular }
          } = await movieApi.popularInfinite(page);
          const totalMovies = [...popular, ...newPopular];
          const uniqByMovies = uniqBy(totalMovies, 'id');

          setPopular(uniqByMovies);
        } catch (error) {
          console.log(error);
        }
      } else if (pathname === '/movie/now-playing') {
        try {
          const {
            data: { results: newNowPlaying }
          } = await movieApi.nowPlayingInfinite(page);
          const totalMovies = [...nowPlaying, ...newNowPlaying];
          const uniqByMovies = uniqBy(totalMovies, 'id');

          setNowPlaying(uniqByMovies);
        } catch (error) {
          console.log(error);
        }
      } else if (pathname === '/movie/top-rated') {
        try {
          const {
            data: { results: newTopRated }
          } = await movieApi.topRatedInfinite(page);
          const totalMovies = [...topRated, ...newTopRated];
          const uniqByMovies = uniqBy(totalMovies, 'id');

          setTopRated(uniqByMovies);
        } catch (error) {
          console.log(error);
        }
      }
    }
  };
  useEffect(() => {
    getMovie();
  }, []);

  useEffect(() => {
    getInfiniteMovie();
  }, [page]);

  return (
    <>
      <Helmet>
        <title>영화 - ScFlix</title>
      </Helmet>
      {loading ? (
        <Loader />
      ) : (
        <Container>
          <PageHeader />
          {pathname === '/movie' && popular && popular.length > 0 && (
            <Section>
              {popular.map(movie => (
                <Poster
                  key={movie.id}
                  id={movie.id}
                  title={movie.title ? movie.title : movie.original_title}
                  posterUrl={movie.poster_path}
                  rating={movie.vote_average}
                  year={
                    movie.release_date && movie.release_date.substring(0, 4)
                  }
                  isMovie={true}
                />
              ))}
            </Section>
          )}
          {pathname === '/movie/now-playing' &&
            nowPlaying &&
            nowPlaying.length > 0 && (
              <Section>
                {nowPlaying.map(movie => (
                  <Poster
                    key={movie.id}
                    id={movie.id}
                    title={movie.title ? movie.title : movie.original_title}
                    posterUrl={movie.poster_path}
                    rating={movie.vote_average}
                    year={
                      movie.release_date && movie.release_date.substring(0, 4)
                    }
                    isMovie={true}
                  />
                ))}
              </Section>
            )}
          {pathname === '/movie/top-rated' && topRated && topRated.length > 0 && (
            <Section>
              {topRated.map(movie => (
                <Poster
                  key={movie.id}
                  id={movie.id}
                  title={movie.title ? movie.title : movie.original_title}
                  posterUrl={movie.poster_path}
                  rating={movie.vote_average}
                  year={
                    movie.release_date && movie.release_date.substring(0, 4)
                  }
                  isMovie={true}
                />
              ))}
            </Section>
          )}
        </Container>
      )}
    </>
  );
};

export default withRouter(Movie);
